import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { isEditing, getSelectedEntityId } from '../../../../entityManagement/selectors';
import { stopEntityEditing } from '../../../../entityManagement/actions';
import { editResource } from '../../../actions/resources';
import { getManualResourceFormInitialValues } from '../../../selectors/resources';
import DismissibleFormWrapper from '../../DismissibleFormWrapper';
import ResourceForm from './ResourceForm';

const SingleResourceEditForm = ({ opened, headerButtonTextKey, onClose, ...other }: $TSFixMe) => (
    <DismissibleFormWrapper opened={opened} headerButtonTextKey={headerButtonTextKey} onClose={onClose}>
        <ResourceForm {...other} />
    </DismissibleFormWrapper>
);

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        opened: isEditing,
        id: getSelectedEntityId,
        initialValues: getManualResourceFormInitialValues,
        headerButtonTextKey: () => TextKey.EditSpace,
    }),
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (dispatch, { scope }) => ({
        onSubmit: (values: $TSFixMe) => {
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'...
            dispatch(editResource(values, scope));
            dispatch(stopEntityEditing(scope));
        },
        onClose: () => dispatch(stopEntityEditing(scope)),
    })
)(SingleResourceEditForm);
